import { render, staticRenderFns } from "./CrossPromotionV2Icon.vue?vue&type=template&id=c6f38e08&"
import script from "./CrossPromotionV2Icon.vue?vue&type=script&lang=js&"
export * from "./CrossPromotionV2Icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports